import Box from "@mui/material/Box";
import React from "react";
import { Link } from "react-router-dom";
import posLogo from "../../../assests/pos_logo.png"
import { Typography } from "@mui/material";
import { IStoreState, useAppSelector } from "../../../redux";
import { useAuthProvider } from "../../../providers";
import { APP_DASHBOARD_V2_ROUTE } from "../../../views/DashboardV2/DashboardV2.contants";

export const LogoIcon: React.FC = () => {

  const customizer = useAppSelector((state: IStoreState) => state.customizer);
  const { user_uuid, authInfo: { user: { role_value } } } = useAuthProvider();
  return (
    <Link to={role_value === "USER" ? "/order-menu?type=TAKE_AWAY" : APP_DASHBOARD_V2_ROUTE} style={{ textDecoration: "none" }}>
      <Box display={"flex"} justifyContent="flex-start">
        {/* <img src={posLogo} height={50} /> */}
        <Typography variant="h5"
          sx={{
            // fontFamily: `"Kanit", sans-serif !important`,
            // fontFamily: `"Teko", sans-serif !important`,
            fontFamily: `"Russo One", sans-serif !important`,
            color: customizer.activeMode === "dark" ? "#fff" : "#20232a",
            fontSize: 36,
            textTransform: "uppercase",
            fontWeight: 700
          }}
        >AirPos</Typography>
      </Box>
    </Link>
  );
};
